import { all, call, put, takeLatest, select } from "redux-saga/effects";
import set from "lodash/set";

import { cloneDeep } from "../../utils/cloneDeep";

import {
  RECEIVE_APPCONFIG,
  receiveAppConfigSuccess,
  receiveAppConfigFail,
  UPDATE_PROSPECT,
  setConfig,
  updateProspect,
  UPDATE_VIEW_ID,
  saveSignatoryModel,
  saveOrganizationInfoModel,
  GET_POSTLOGIN_TOKEN_REQUEST,
  setAccessToken,
  getProspectInfoSuccess,
  getProspectInfoFail
} from "../actions/appConfig";
import { sendProspectToAPI, sendProspectToAPISuccess } from "../actions/sendProspectToAPI";
import { config, postAuthToken } from "../../api/apiClient";
import {
  accountNames,
  UAE_CODE,
  UAE,
  UAE_CURRENCY,
  AUTO,
  AUTH_CLIENT_ID,
  AUTH_RESOURCE_TYPE
} from "../../constants";
import {
  getIsIslamicBanking,
  getAccountType,
  getProspect,
  getLeadSource,
  getRoCode,
  getAuthorizationHeader,
  getDeviceID
} from "../selectors/appConfig";
import { log } from "../../utils/loggger";
import { parseJwt } from "../../utils/genericUtils";

export function* receiveAppConfigSaga(action) {
  try {
    const useExistingToken = action.payload;
    const headers = yield select(getAuthorizationHeader);
    const accountType = yield select(getAccountType);
    let response = null;

    if (accountType) {
      response = yield call(
        config.load,
        accountType,
        undefined,
        useExistingToken ? headers : undefined
      );
    } else if (process.env.NODE_ENV === "development") {
      response = yield call(
        config.load,
        accountNames.starter,
        undefined,
        useExistingToken ? headers : undefined
      );
    } else {
      response = yield call(config.load, null, undefined, useExistingToken ? headers : undefined);
    }

    const newConfig = response.data;
    const signatoryModel = newConfig.prospect
      ? cloneDeep(newConfig.prospect.signatoryInfo[0])
      : null;
    const organizationInfoModel = newConfig.prospect
      ? cloneDeep(newConfig.prospect.organizationInfo)
      : null;

    if (newConfig.prospect) {
      newConfig.prospect.signatoryInfo = [];
      newConfig.prospect.accountInfo[0].accountCurrency = UAE_CURRENCY;
      if (!newConfig.prospect.applicantInfo.countryCode) {
        newConfig.prospect.applicantInfo.countryCode = UAE_CODE;
      }
      newConfig.prospect.applicantInfo.LeadSource = yield select(getLeadSource);
      newConfig.prospect.applicantInfo.roCode = yield select(getRoCode);
      newConfig.prospect.applicationInfo.accountType = yield select(getAccountType);
      newConfig.prospect.applicationInfo.islamicBanking = yield select(getIsIslamicBanking);
      newConfig.prospect.organizationInfo.addressInfo[0].addressDetails[0].country = UAE;
      newConfig.prospect.organizationInfo.addressInfo[0].addressDetails[0].preferredAddress = "Y";
    }

    if (signatoryModel) {
      yield put(saveSignatoryModel(signatoryModel));
    }
    if (organizationInfoModel) {
      yield put(saveOrganizationInfoModel(organizationInfoModel));
    }
    yield put(receiveAppConfigSuccess(newConfig));
    yield put(sendProspectToAPISuccess());
  } catch (error) {
    log(error);
    yield put(receiveAppConfigFail(error));
  }
}

export function* updateProspectSaga(action) {
  const state = yield select();
  const prospect = cloneDeep(getProspect(state));
  const newConfig = {
    ...state.appConfig,
    prospect
  };

  for (let name in action.payload) {
    set(newConfig, name, action.payload[name]);
  }

  yield put(setConfig(newConfig));
}

export function* updateViewIdSaga({ payload: { viewId, isSendToApi } }) {
  yield put(updateProspect({ "prospect.applicationInfo.viewId": viewId }));
  if (isSendToApi) {
    yield put(sendProspectToAPI(AUTO));
  }
}

export function* getPostLoginTokenSaga({ payload: { prospectId, deviceId = "", uniqueId = "" } }) {
  try {
    const headers = yield select(getAuthorizationHeader);
    const DEVICE_ID = yield select(getDeviceID);
    let finalUniqueId = uniqueId;
    if (!finalUniqueId) {
      const jwtData = parseJwt(headers.headers.Authorization);
      finalUniqueId = jwtData?.deviceId || "";
    }
    const authTokenData = {
      client_id: AUTH_CLIENT_ID,
      resource_type: AUTH_RESOURCE_TYPE,
      client_secret: process.env.REACT_APP_AUTH_CLIENT_SECRET,
      device_id: deviceId || DEVICE_ID,
      apiKey: process.env.REACT_APP_AUTH_API_KEY,
      unique_id: finalUniqueId,
      resource_id: prospectId
    };

    const { data } = yield call(postAuthToken.get, authTokenData, headers);
    const { access_token = "", refresh_token = "" } = data;
    yield put(setAccessToken(access_token, refresh_token));
    yield put(getProspectInfoSuccess(data));
  } catch (error) {
    log(error);
    yield put(getProspectInfoFail(error));
  }
}
export default function* appConfigSaga() {
  yield all([
    takeLatest(RECEIVE_APPCONFIG, receiveAppConfigSaga),
    takeLatest(UPDATE_PROSPECT, updateProspectSaga),
    takeLatest(UPDATE_VIEW_ID, updateViewIdSaga),
    takeLatest(GET_POSTLOGIN_TOKEN_REQUEST, getPostLoginTokenSaga)
  ]);
}
